export default __webpack_public_path__ + "static/media/home-first-vector.2754504d.svg";